import React from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomTabset from "../Components/CustomTabset/CustomTabset";
import {globals} from "../Components/Globals/Globals.js";
import { loadBlogs } from "../redux/blogSlice.js";

// reactstrap components
import {Container, Row} from "reactstrap";

// core components
import BlogsRawTableDataSync from "../Components/BlogsRawTableDataSync/BlogsRawTableDataSync";


const AdminBlogsView = (props) => {
  const dispatch = useDispatch();

  // Get the stats from the store
  const {blogsItems, loadBlogs_result} = useSelector((state) => state.blogs)
  
  React.useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let isMounted = true

    // If status is !loading, then fetch stats data from the API
    if (loadBlogs_result.status === 'idle'){
      if (globals.parameters.redux_debugging) alert("loading blogs")
      dispatch(loadBlogs());
    }

    if (loadBlogs_result.status === 'loading'){
      if (globals.parameters.redux_debugging) alert("loading blogs...")
    }

    // If status is !loading, then fetch stats data from the API
    if (loadBlogs_result.status === 'succeeded'){
      if (globals.parameters.redux_debugging) alert("stats successfully loaded")
        console.log("AdminBlogsView -> blogsItems", blogsItems)
    }

    // Cleanup function
    return () => {
      isMounted = false
    }
  }, [loadBlogs_result, dispatch]);


  return (    
        <div className="wrapper">
          <div className="main">
            <div className="section">
              <Container>
                {/** Search toolbar */}
                <CustomTabset activeTabset={"blogs"}/>
                <Row>
                  <div>
                      {blogsItems  &&
                      <BlogsRawTableDataSync
                        blog_list = {blogsItems}
                        current_session={null}
                        //stat_filter={stat_or_admin_filter()}
                        stat_filter={null}/>}                 
                </div>
                </Row> 
              </Container>
            </div>
          </div>
        </div>
  );
}

export default AdminBlogsView;